import * as React from "react";
import {
  TiHomeOutline,
  TiClipboard,
  TiCalendar,
  // TiMessages,
  TiChartBarOutline,
  TiGroup,
  TiLocationOutline,
  TiUser,
  TiSpannerOutline,
  TiDownload,
  TiStarOutline
} from "react-icons/ti";

export const NAV_ITEMS: Array<any> = [
  {
    to: "/dashboard",
    title: "Dashboard",
    icon: <TiHomeOutline size="1.3em" />
  },
  {
    to: "/work-orders",
    title: "Work Orders",
    icon: <TiClipboard size="1.3em" />
  },
  {
    to: "/schedule",
    title: "Schedule",
    icon: <TiCalendar size="1.3em" />
  },
  {
    to: "/reports",
    title: "Reports",
    icon: <TiChartBarOutline size="1.3em" />
  },
  {
    to: "/users",
    title: "Users",
    icon: <TiGroup size="1.3em" />
  },
  {
    to: "/parts",
    title: "Parts",
    icon: <TiSpannerOutline size="1.3em" />
  },
  {
    to: "/requests",
    title: "Requests",
    icon: <TiDownload size="1.3em" />
  },
  {
    to: "/sites",
    title: "Sites",
    icon: <TiLocationOutline size="1.3em" />
  },
  {
    to: "/assets",
    title: "Assets",
    icon: <TiStarOutline size="1.3em" />
  },
  {
    to: "/customers",
    title: "Customers",
    icon: <TiUser size="1.3em" />
  }
  /*{
    to: "/messages",
    title: "Messages",
    icon: <TiMessages size="1.3em" />
  } */
];



// WEBPACK FOOTER //
// ./src/Navigation/NavItems.tsx